import { Record } from "immutable";

export class ReportingAnchor extends Record({
    id: null,
    name: null
}) {}
